export class Cnae {
  codigo: string;
  descricao: string;
}
